// extracted by mini-css-extract-plugin
module.exports = {"divider":"Splitter_divider","root":"Splitter_root","panel":"Splitter_panel"};